module.exports = __webpack_public_path__ + "img/exclamation-mark-icon.bfd3ea4f.svg";